import React from 'react';
import facebookIcon from '../../../../../src/assets/img/footerIcons/fb-white.png';
import instaIcon from '../../../../assets/img/footerIcons/ig-white.png';
import linkedinIcon from '../../../../assets/img/footerIcons/IN-white.png';
import twitterIcon from '../../../../assets/img/footerIcons/tw-white.png';
import youtubeIcon from '../../../../assets/img/footerIcons/YT-white.png';
import { getUserLocale, replaceTokensInStrings } from "../../../../helpers/helper";
import { DASHBOARD_FAQS_PATH, DASHBOARD_SETTINGS_PATH } from "../../../../constants/paths";

const iconsMapping = {
  facebook: facebookIcon,
  instagram: instaIcon,
  linkedin: linkedinIcon,
  twitter: twitterIcon,
  youtube: youtubeIcon
};

export default function FooterMain(props) {
  const userLocale = getUserLocale(props.configs.data);
  let socialMediaIcons = props.configs && props.configs.data ? JSON.parse(props.configs.data["social-media-links"]) : [];
  const displayIcons = socialMediaIcons.map((socialMedia, index) => {
    return (
      <a href={socialMedia.link} className="utility-social-media-icon" target="_blank" key={index}>
        <img src={iconsMapping[socialMedia.name]} alt={index} className={socialMedia.name}></img>
      </a>
    )
  });

  const getPrivacyNote = (note) => {
    let tokenMappings = [
      { key: "{faqsLink}", value: DASHBOARD_FAQS_PATH },
      { key: "{className}", value: "link" },
      { key: "{privacyLink}", value: props.configs.data ? props.configs.data["privacyLink_" + userLocale] : "#" },
      { key: "{privacyNoticeLink}", value: props.configs.data ? props.configs.data["privacyNoticeLink_" + userLocale] : "#" },
      { key: "{unsubscribeLink}", value: DASHBOARD_SETTINGS_PATH + "?tab-type=alertType" }
    ];
    note = replaceTokensInStrings(note, tokenMappings);
    return note;
  };
  const footerCss = props.configs.data["footer.footer_css_container_class"];
  let addressLine1 = props.translations.data["UTILITY_INFO.ADDRESS_LINE1"];
  
  const updateTokenInStrings = (stringValue) => {
    let tokenMappings = [
      { key: "{year}", value: new Date().getFullYear() }
    ];
    stringValue = replaceTokensInStrings(stringValue, tokenMappings);
    return stringValue;
  };

  return (  
    <div className="utility-footer">
      <div className={`${footerCss} utility-footer-container` } >
        <div className="utility-social-media-icons">
          {displayIcons}
        </div>
        <div className="utility-name">
         {props.translations.data["UTILITY_INFO.NAME"]}
        </div>
        {
          props.footerNote ? 
            (<div className="privacy-note">
              <span dangerouslySetInnerHTML={{ __html: getPrivacyNote(props.footerNote) }}></span>
              <br />
            </div>
            ) : ''
        }
        <span className="utility-address">
          <span dangerouslySetInnerHTML={{ __html: updateTokenInStrings(addressLine1) }}></span>
          {props.translations.data["UTILITY_INFO.ADDRESS_LINE2"] ?
            (
              <span>
                <br />
                {props.translations.data["UTILITY_INFO.ADDRESS_LINE2"]}
              </span>
            )
            : ''
          }
          {props.translations.data["UTILITY_INFO.ADDRESS_ZIPCODE"] ?
            (
              <span>
                <br />
                {props.translations.data["UTILITY_INFO.ADDRESS_ZIPCODE"]}
              </span>
            )
            : ''
          }
        </span>
        {
          props.translations.data["COPY_RIGHT_NOTE"] && 
          (
            <span className="utility-address">
              <br />
              {props.translations.data["COPY_RIGHT_NOTE"]}
            </span>
          )
        }
        <div className="utility-phone">
          {props.translations.data["UTILITY_INFO.PHONE_NO"]}
        </div>
        <div className="utility-email">
          {props.translations.data["UTILITY_INFO.EMAIL"]}
        </div>
        {
          props.configs.data["showTOSlink"] == "true" ?
            (
              <div className="utility-tos">
                <a href={props.configs.data["termsLink_" + userLocale] ? props.configs.data["termsLink_" + userLocale] : "#"} rel="noopener noreferrer" target="_blank">{props.translations.data["UTILITY_INFO.TERMS_OF_SERVICE"]}</a>
                {props.configs.data["showPrivacyLink"] == "true" ?
                  (
                    <a href={props.configs.data["privacyLink_" + userLocale] ? props.configs.data["privacyLink_" + userLocale] : "#"} rel="noopener noreferrer" target="_blank" >{props.translations.data["UTILITY_INFO.PRIVACY_POLICY"]}</a>
                  )
                  : ''
                }
              </div>
            ) :
            ''
        }
      </div>
    </div>
  );
}
